import { apiUrl, buildAuthHeaders } from '../config/api';

export async function submitFeedback(
  chatId: string,
  messageId: string,
  value: 'up' | 'down',
  reasons?: string[],
  text?: string
): Promise<void> {
  const headers = await buildAuthHeaders();
  await fetch(apiUrl('/feedback'), {
    method: 'POST',
    headers,
    body: JSON.stringify({ chatId, messageId, value, reasons, text }),
  });
}

export async function removeFeedback(
  chatId: string,
  messageId: string
): Promise<void> {
  const headers = await buildAuthHeaders();
  await fetch(apiUrl('/feedback'), {
    method: 'DELETE',
    headers,
    body: JSON.stringify({ chatId, messageId }),
  });
}
